import styles from './StatCard.module.css';

/**
 * StatCard
 * ────────
 * Reusable summary / KPI card used across accounting pages.
 *
 * @param {ReactNode} icon       Icon element
 * @param {string}    iconBg     Background color for icon bubble (e.g. 'rgba(99,102,241,0.12)')
 * @param {string}    iconColor  Icon foreground color (e.g. '#6366f1')
 * @param {string}    label      Small label above the value
 * @param {string}    value      Main displayed value
 * @param {'default'|'green'|'red'|'blue'} valueColor
 *
 * Usage:
 *   <StatCard
 *     icon={<FiDollarSign size={18} />}
 *     iconBg="rgba(99,102,241,0.12)"
 *     iconColor="#6366f1"
 *     label={SUMMARY.totalPledged}
 *     value={`₹${fmt(totalPledged)}`}
 *   />
 */
export default function StatCard({ icon, iconBg, iconColor, label, value, valueColor = 'default' }) {
  return (
    <div className={styles.card}>
      {icon && (
        <div
          className={styles.iconWrap}
          style={{ background: iconBg, color: iconColor }}
        >
          {icon}
        </div>
      )}
      <div className={styles.body}>
        <div className={styles.label}>{label}</div>
        <div className={`${styles.value} ${styles[valueColor] || ''}`}>{value}</div>
      </div>
    </div>
  );
}
